module.exports = __webpack_public_path__ + "img/112.other_aspect_of_service.9635b0dd.svg";